import { atom } from 'recoil';
import { PickMealTime } from '~/types';

const pickMealTime = atom<PickMealTime>({
  key: 'pickMealTime',
  default: PickMealTime.IMMEDIATELY,
});

export default pickMealTime;
